export default {"src":"/_next/static/media/cider-fallback.c196c869.svg","height":320,"width":320};